import { Chip, Grid } from "@mui/material";
import { BlockedIcon, CheckCircleIcon, UserIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { CoinsIcon } from "Components/_Shared/Icons/Icons";
import { Tile } from "Components/_Shared/Tile";
import { useGetAnalysisClients } from "Infrastructure/ApiZfp/AnalyzerApi";
import type { FinancialAssetItem } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { FINANCIAL_SUBTYPE_RESOURCE_KEY } from "Infrastructure/Utils/AssetUtils";
import { formatClientName } from "Infrastructure/Utils/ClientUtils";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { type FC, useContext } from "react";
import { AnalysisDetailContext } from "../Detail/AnalysisDetailContext";

type Props = {
  readonly asset: FinancialAssetItem;
  readonly onEdit: () => void;
};

export const FinancialAssetTile: FC<Props> = ({ asset, onEdit }) => {
  const { versionId, analysisId } = useContext(AnalysisDetailContext);
  const { t } = useResource();

  const { data: clientsData } = useGetAnalysisClients(analysisId, versionId);

  const client = clientsData?.clients.find((client) => client.guid === asset.clientGuid);
  return (
    <Tile title={asset.name} subtitle={asset.note ?? undefined} onClick={onEdit}>
      <Grid container gap={Spacing.M}>
        <Chip
          size="small"
          label={t(Resources.AnalysisDetail.Assets.Financial.FinancialAssetType[FINANCIAL_SUBTYPE_RESOURCE_KEY[asset.financialSubType]])}
        />
        <Chip size="small" icon={<CoinsIcon />} label={formatCurrency(asset.amount.value, asset.amount.currencyCode)} />
        {client && <Chip size="small" color="info" icon={<UserIcon />} label={formatClientName(client.firstName, client.surname, null)} />}
        <Chip
          size="small"
          color={asset.isUsableForGoals ? "success" : "error"}
          icon={asset.isUsableForGoals ? <CheckCircleIcon /> : <BlockedIcon />}
          label={t(asset.isUsableForGoals ? Resources.AnalysisDetail.Assets.Usable : Resources.AnalysisDetail.Assets.Unusable)}
        />
      </Grid>
    </Tile>
  );
};
